import { notifications } from "@mantine/notifications"
import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import {
  UpdateProductionSiteFieldDefinition,
  UpdateProductionSiteFieldDefinitionParams,
} from "@tfg/types/schemas/modules/traceability/queries/update-production-site-field-definition.dto"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useUpdateProductionSiteFieldDefinitionMutation = (
  params: UpdateProductionSiteFieldDefinitionParams,
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    UpdateProductionSiteFieldDefinition
  >
) =>
  useMutation({
    mutationFn: async (data: UpdateProductionSiteFieldDefinition) => {
      return await httpClient.put(
        `/admin/traceability/update-production-site-field-definition/${params.id}`,
        data
      )
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      queryClient.invalidateQueries(["prodSiteFieldDefs"])
      notifications.show({
        title: "Success",
        message: "Production field definition updated",
        color: "green",
      })
    },
    onError: (error: AxiosError) => {
      notifications.show({
        title: "Error",
        message: error.message,
        color: "red",
      })
    },
  })
